import type { ICreateBulkSupraSubscriptionsBody } from '@/app-package';
import axios from 'axios';

const createBulkSupraSystemSubscriptions = async (
  body: ICreateBulkSupraSubscriptionsBody,
) => {
  await axios.post('/supra_system/subscription/create_bulk', body);
};

export default createBulkSupraSystemSubscriptions;
